import script from "./PortfolioSection.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioSection.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioSection.vue?vue&type=style&index=0&id=313fe50c&lang=css"

const __exports__ = script;

export default __exports__